import { NumberFormatLocale } from '../../../../../utils/numberFormat';

export function dynamicCellCacheKey(
  rowIndex: number,
  colIndex: number,
  until: string | undefined,
  locale: NumberFormatLocale
): string {
  return `${rowIndex}-${colIndex}-${until || ''}-${locale}`;
}

export function dynamicFieldCacheKey(
  section: string,
  field: string,
  until: string | undefined,
  locale: NumberFormatLocale
): string {
  return `${section}.${field}-${until || ''}-${locale}`;
}
